export default {
  path: 'tasks',
  name: 'project-issues',
  component: () => import(/* webpackChunkName: "project-issues" */ './IssuesList.vue'),
  redirect: {
    name: 'project-issues-home',
  },
  meta: {
    hideProject: true,
  },
  children: [
    {
      path: '',
      name: 'project-issues-home',
      component: () => import(/* webpackChunkName: "project-issues-home" */ './NoIssues.vue'),
      meta: { hideProject: true },
    },
    {
      path: ':issueId',
      name: 'project-issue',
      component: () => import(/* webpackChunkName: "single-issue" */ './Issue.vue'),
      meta: { hideProject: true },
    },
    {
      path: '*',
      redirect: {
        name: 'project-issues-home',
      },
    },
  ],
};
